import React from 'react';
import { FileChip } from './FileChip';

/**
 * The user's turn in a clip's chat: the uploaded file, what they said about it, or both. Only the
 * user gets a bubble; the assistant's replies are the analysis card or plain text.
 */
export const ClipMessage = ({ filename, version, note }) => (
  <div className="self-end ml-auto max-w-[80%] flex flex-col items-end gap-space-2">
    {filename && <FileChip filename={filename} version={version} />}
    {note && (
      // Rounded on every corner but the one pointing at the user's side
      <p className="m-0 px-space-4 py-space-3 rounded-radius-lg rounded-br-[6px] bg-ink text-on-light font-text text-body whitespace-pre-wrap break-words">
        {note}
      </p>
    )}
  </div>
);
